export default "__VITE_ASSET__DdQde70n__"